import React from "react";

const Img = ({src,alt,className,...restProps})=>{
    return(
    <>
     <img className={className} src={src} alt={alt} {...restProps}  height={"100%"} width={"100%"} />
    </>
    );
}
export {Img};